<template>
    <div v-if="service" class="container my-5">
      <h2 class="text-center mb-4">{{ service.title }}</h2>
      <img :src="service.image" class="img-fluid mb-4" :alt="service.title" />
      <p class="lead">{{ service.description }}</p>
      <router-link to="/contact" class="btn btn-orange mt-3">Book Now</router-link>
    </div>
  
    <div v-else class="text-center mt-5">
      <p>Service not found.</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        services: {
          fiat500: {
            title: "Fiat 500 Classic Experience",
            description: "Drive a Vintage Fiat 500 and explore Rome like never before. Enjoy the charm of this iconic car while your guide takes you through narrow streets, historic spots, and scenic viewpoints.",
            image: require('@/assets/images/service1-1.jpg')
          },
          vespa: {
            title: "Vespa Tour",
            description: "Ride through Rome like a local on a stylish Vespa. A perfect way to explore the narrow alleyways and scenic hills of the Eternal City.",
            image: require('@/assets/images/service1-2.jpg')
          },
          golfcart: {
            title: "Golf Cart Experience",
            description: "Tour the historic center comfortably in an electric golf cart. Ideal for families and those looking for a relaxed sightseeing experience.",
            image: require('@/assets/images/service3-2.jpg')
          },
          segway: {
            title: "Segway City Tour",
            description: "Effortlessly glide through Rome’s landmarks on a Segway. Fun, fast, and informative — great for adventurous travelers.",
            image: require('@/assets/images/service3-1.jpg')
          }
          // ➕ Add more here as you go!
        }
      };
    },
    computed: {
      service() {
        return this.services[this.$route.params.slug];
      }
    }
  };
  </script>
  
  <style scoped>
  .btn-orange {
    background-color: #f26522;
    color: white;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 5px;
  }
  .btn-orange:hover {
    background-color: #d3541f;
  }
  </style>
  